import type { Security } from '../../types/Security';
import { ProductTypeEnum } from '../../types/types';

type SecurityIconFields = Pick<Security, 'ProductType' | 'DisplaySymbol' | 'BaseCurrency'>;

/**
 * Chooses the string passed to {@link CurrencyIcon} for a security row.
 * Share icons have no dedicated SVGs; use DisplaySymbol so the letter fallback
 * is the first character of the display label (e.g. "A" for "AAPL Stock")
 * instead of BaseCurrency / an opaque name.
 */
export function resolveSecurityIconCurrency({
  security,
  currency,
  symbol,
}: {
  security?: Partial<SecurityIconFields>;
  currency?: string;
  symbol?: string;
}): string | undefined {
  if (security?.ProductType === ProductTypeEnum.Share) {
    return security.DisplaySymbol || currency || security.BaseCurrency || symbol?.split('-')[0];
  }

  return currency || security?.BaseCurrency || symbol?.split('-')[0];
}
